import { getControlItem, togglePictureInPicture } from '../utils/helpers'
import { BUTTON_ICON_CLASS, CONTROL_CLASS } from '../utils/videoplayer-constants'
import { Controls } from './controls'

export class PictureInPicture extends Controls {
  constructor(element: HTMLElement, videoPlayer: HTMLVideoElement, wrapperElement: HTMLDivElement) {
    super(element, videoPlayer, wrapperElement)
    this.renderPictureInPictureButton()
  }

  private renderPictureInPictureButton() {
    this.controlBarSectionElement.appendChild(
      getControlItem({
        parent: {
          element: 'button',
          classes: [CONTROL_CLASS, 'cmp-video-wrapper__controls--picture-in-picture'],
        },
        children: [
          { element: 'span', classes: [BUTTON_ICON_CLASS, 'cmp-button__icon--miniplayer'] },
          { element: 'span', classes: [BUTTON_ICON_CLASS, 'cmp-button__icon--miniplayer-exit'] },
        ],
        eventListeners: ['click'],
        callback: () => togglePictureInPicture(this.videoPlayer, this.wrapperElement),
      }),
    )
  }
}
